<div class="landing-page">
  <mat-toolbar>
    <img src="assets/img/EnBW_Logo.png" alt="EnBW Logo" class="enbw-logo">
    <span routerLink="home" class="app-name">Roaming UI - {{ stage | translate }}</span>


    <button mat-button routerLink="cpo" routerLinkActive="mat-mdc-raised-button active-button">CPO
    </button>
    <button mat-button routerLink="emp" routerLinkActive="mat-mdc-raised-button active-button">EMP
    </button>

    <span class="spacer"></span>
    <div class="language-user-container">
      <div class="language-select" [matMenuTriggerFor]="languageMenu">
        <div class="language-selection-box">
          <span class="content">{{ selectedLanguage }}</span>
        </div>
      </div>
      <mat-icon style="margin-left: 5px">account_circle</mat-icon>
      <div [matMenuTriggerFor]="userMenu" style="margin-left: 5px">
        <span class="username">{{ username }}</span>
      </div>
    </div>
    <button class="version-info-button" mat-button routerLink="versionInfo">
      <mat-icon>settings</mat-icon>
    </button>
  </mat-toolbar>
  <mat-menu #languageMenu="matMenu">
    <button mat-menu-item (click)="changeLanguage('en')">English</button>
    <button mat-menu-item (click)="changeLanguage('de')">Deutsch</button>
  </mat-menu>
  <mat-menu #userMenu="matMenu">
    <roaming-user [userData]="userData"></roaming-user>
  </mat-menu>
</div>
